import { Link, useParams } from "react-router";
import type { PortalConfig } from "../config";
import type { Lookups } from "../types";
import { EstimateDraftProvider } from "./ticket/estimateDraft";
import { Header } from "./ticket/Header";
import { CheckInCard, ImagesCard, NotesCard, PaymentCard, ReturnsCard, ShippingLabelCard } from "./ticket/LeftColumn";
import { ExpensesCard, ServicesCard, TouchesCard } from "./ticket/MiddleColumn";
import { EstimateCard, LinksCard, MessagesCard, PublishedEstimatesCard } from "./ticket/RightColumn";
import { AddressCard, CustomerCard, ReturnLabelCard, SummaryCard } from "./ticket/TopRow";
import { TicketContext, useTicket } from "./ticket/useTicket";

/** One ticket, laid out like the owner's mockup (Nov 3). */
export function TicketPage({ config, lookups }: { config: PortalConfig; lookups: Lookups | null }) {
  const { ticketNo = "" } = useParams();
  const { detail, loadError, problem, setProblem, notice, setNotice, saving, save, reload } = useTicket(config, ticketNo);

  if (loadError) return <div className="tp"><p><Link to="/tickets">← Tickets</Link></p><p className="error">{loadError}</p></div>;
  if (!detail || String(detail.ticket.ticketNo) !== ticketNo) return <div className="tp"><p className="muted">Loading ticket…</p></div>;

  return (
    <TicketContext.Provider value={{ config, lookups, detail, save, saving, reload, notify: setNotice }}>
      <EstimateDraftProvider>
        <div className="tp">
          <Header />
          {problem && (
            <div className={problem.conflict ? "problem conflict" : "problem"} role="alert">
              <span>{problem.text}</span>
              {problem.conflict && <button type="button" className="btn outline" onClick={reload}>Reload ticket</button>}
              <button type="button" className="link-btn" onClick={() => setProblem(null)}>Dismiss</button>
            </div>
          )}
          {notice && (
            <div className="notice" role="status">
              <span>{notice}</span>
              <button type="button" className="link-btn" onClick={() => setNotice(null)}>Dismiss</button>
            </div>
          )}
          <div className="tp-top">
            <SummaryCard /><CustomerCard /><AddressCard /><ReturnLabelCard />
          </div>
          <div className="tp-cols">
            <div className="col"><ImagesCard /><CheckInCard /><PaymentCard /><ShippingLabelCard /><ReturnsCard /><NotesCard /></div>
            <div className="col"><ServicesCard /><ExpensesCard /><TouchesCard /></div>
            <div className="col"><EstimateCard /><PublishedEstimatesCard /><LinksCard /><MessagesCard /></div>
          </div>
        </div>
      </EstimateDraftProvider>
    </TicketContext.Provider>
  );
}
